"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _looksLikePostcode = require("./looks-like-postcode");
var _looksLikePostcode2 = _interopRequireDefault(_looksLikePostcode);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var postcodeMessage = "Sorry we don't recognise your postcode";
exports.default = (0, _looksLikePostcode2.default)(postcodeMessage);